import React from "react";
import { Box, Button, IconButton, Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography, } from "@material-ui/core";
import { Add, Delete } from "@material-ui/icons";
import { Skeleton } from "@material-ui/lab";
import { useClient } from "frontend/src/domain/client";
import { useAddClientSite, useDeleteClientSite, } from "frontend/src/domain/client/actions";
export var ClientSites = function (_a) {
    var clientId = _a.clientId;
    var _b = useClient(clientId), client = _b.data, isFetched = _b.isFetched;
    var addSite = useAddClientSite(clientId);
    var deleteSite = useDeleteClientSite(clientId);
    var _c = React.useState(""), name = _c[0], setName = _c[1];
    var onAdd = function () {
        var trimmedName = name.trim();
        if (!trimmedName) {
            return;
        }
        addSite.mutate({ name: trimmedName }, {
            onSuccess: function () { return setName(""); },
        });
    };
    return (React.createElement(Box, { component: Paper, p: 2 },
        React.createElement(Typography, { variant: "h6" }, "\u0410\u0434\u0440\u0435\u0441\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F"),
        React.createElement(Box, { display: "flex", mt: 2 },
            React.createElement(TextField, { label: "Адрес или название точки", value: name, onChange: function (event) { return setName(event.target.value); }, fullWidth: true }),
            React.createElement(Box, { ml: 1 },
                React.createElement(Button, { color: "primary", variant: "contained", startIcon: React.createElement(Add, null), onClick: onAdd, disabled: addSite.isLoading }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C"))),
        React.createElement(Box, { mt: 2 }, !isFetched ? (React.createElement(Skeleton, null)) : (client === null || client === void 0 ? void 0 : client.sites) && client.sites.length > 0 ? (React.createElement(Table, { size: "small" },
            React.createElement(TableHead, null,
                React.createElement(TableRow, null,
                    React.createElement(TableCell, null, "\u0410\u0434\u0440\u0435\u0441"),
                    React.createElement(TableCell, { width: "5%" }))),
            React.createElement(TableBody, null, client.sites.map(function (site) { return (React.createElement(TableRow, { key: site.id },
                React.createElement(TableCell, null, site.name),
                React.createElement(TableCell, null,
                    React.createElement(IconButton, { size: "small", onClick: function () { return deleteSite.mutate(site.id); } },
                        React.createElement(Delete, { fontSize: "small" }))))); })))) : (React.createElement(Typography, { color: "textSecondary" }, "\u0410\u0434\u0440\u0435\u0441\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u043F\u043E\u043A\u0430 \u043D\u0435 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u044B.")))));
};
